import { Theme, makeStyles } from "@material-ui/core";

export const useStyles = makeStyles((_theme: Theme) => ({
    playline: {
        width: "100%",
        aspectRatio: 27,
        borderRadius: 100,
        overflow: "hidden",
    }
}));